import React from 'react';

import './style.scss';

const FallBack = (props) => {
  const { history } = props;

  return (
    <div id="fallback-content">
      <h2>Oops, we couldn&apos;t find this page!</h2>
      <p>Check to make sure you are logged in and the URL you requested is correct.</p>
      <button id="home-button" type="button" onClick={() => history.push('/')}>Click Here To Go Home</button>
    </div>
  );
};

export default FallBack;
